import { useEffect } from 'react';
import env from 'utils/env';
import useScript, { SCRIPT_STATUS } from './useScript';

const fbScriptUrl = 'https://connect.facebook.net/en_US/sdk.js';

const useFacebookScript = () => {
  const fbScriptStatus = useScript(fbScriptUrl);
  useEffect(() => {
    if (fbScriptStatus === SCRIPT_STATUS.ready) {
      window.fbAsyncInit = function() {
        window.FB.init({
          appId: env.fbAppId,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v12.0',
        });
      };
    }
  }, [fbScriptStatus]);
};

export default useFacebookScript;
